import { Modal } from '@react-apps/design-system';
import type { SaleWebhookInbox } from '../../domain/entities/sales.entity';
import {
  describeWebhookInboxStatusReason,
  ErrorBanner,
  InfoNotice,
  Mono,
} from '../shared/display';

interface JsonPayloadModalProps {
  open: boolean;
  onClose: () => void;
  row: SaleWebhookInbox | null;
}

/** Payload cru, formatado — o miolo do modal abaixo e do "Webhook de origem". */
export function JsonBlock({ value }: { value: unknown }) {
  return (
    <pre className="bg-(--color-bg-secondary) text-(--color-text-primary) max-h-[60vh] overflow-auto whitespace-pre-wrap rounded-lg p-4 font-mono text-xs">
      {value == null ? null : JSON.stringify(value, null, 2)}
    </pre>
  );
}

/**
 * Por que a row terminou ignorada ou com falha, acima do payload. A row já
 * chega carregada da listagem, então não há loading nem erro próprios. O
 * `statusDetail` é sempre texto puro: no `failed` é a mensagem do erro.
 */
function StatusReasonNotice({ row }: { row: SaleWebhookInbox }) {
  if (!row.statusReason) return null;
  const reason = describeWebhookInboxStatusReason(row.statusReason);
  if (row.status === 'failed') {
    return (
      <div className="space-y-2">
        <ErrorBanner message={reason.text} />
        {row.statusDetail && (
          <pre className="bg-(--color-bg-secondary) text-(--color-text-primary) max-h-48 overflow-auto whitespace-pre-wrap rounded-lg p-3 font-mono text-xs">
            {row.statusDetail}
          </pre>
        )}
      </div>
    );
  }
  return (
    <InfoNotice>
      {reason.text}
      {reason.detailLabel && row.statusDetail && (
        <>
          <br />
          {reason.detailLabel}: <Mono>{row.statusDetail}</Mono>
        </>
      )}
    </InfoNotice>
  );
}

/** Motivo do status e payload bruto do webhook, para inspeção manual. */
export function JsonPayloadModal({
  open,
  onClose,
  row,
}: JsonPayloadModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="Detalhes do webhook" size="lg">
      {row && (
        <div className="space-y-4">
          <StatusReasonNotice row={row} />
          <JsonBlock value={row.payload} />
        </div>
      )}
    </Modal>
  );
}
